<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#FF3B30"
    :border="true"
    inactive-color="#999999"
    z-index="999"
  >
    <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home.png' : '/img/footer/home.png'"
          :alt="$t('foorter.index')"
          style="width: 24PX; height: 24PX;"
        />
      </template>
    </van-tabbar-item>

    <!-- 订单 -->
    <van-tabbar-item to="/GameRecord">
      <span>{{$t("foorter.top23")}}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/order.png' : '/img/footer/order.png'"
          :alt="$t('auth.top4')"
          style="width: 24PX; height: 24PX;"
        />
      </template>
    </van-tabbar-item>


    <!-- 活动 -->
    <van-tabbar-item to="/Game">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/img/dt.png' : '/img/img/dt.png'"
          :alt="$t('foorter.video')"
          style="width: 24PX; height: 24PX;"
        />
      </template>
    </van-tabbar-item>

    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/mine.png' : '/img/footer/mine.png'"
          :alt="$t('foorter.my')"
          style="width: 24PX; height: 24PX;"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "GameRecord") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "game") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 3;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "GameRecord") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "game") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 3;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
/* 底部导航整体高度 */
.van-tabbar {
  height: 60PX;
  background: #fff;
  box-shadow: 0 -1PX 5PX rgba(0, 0, 0, 0.05);
}

/* 每个Tab项 */
.van-tabbar-item {
  font-size: 12PX;
  line-height: 20PX;
  color: #999;
  
  /* 选中状态颜色 */
  &.van-tabbar-item--active {
    color: #FF3B30;
  }
}

/* 图标尺寸 */
.van-tabbar-item__icon img {
  width: 24PX;
  height: 24PX;
  object-fit: contain;
  display: block;
}

/* 中间凸起的商家图标 */
.center-tab {
  position: relative;
  
  /* 隐藏默认图标占位 */
  .van-tabbar-item__icon {
    position: absolute;
    top: -100PX;
    left: 50%;
    transform: translateX(-50%);
    width: 50PX;
    height: 50PX;
    z-index: 10;
  }
  
  /* 凸起的圆角橙色方块 */
  .center-icon {
    width: 50PX;
    height: 50PX;
    border-radius: 12PX;
    display: flex;
    align-items: center;
    justify-content: center;
    
    
    img {
      width: 40PX;
      height: 40PX;
      object-fit: contain;
    }
  }
  
  /* 文字下移 */
  .van-tabbar-item__text {
    margin-top: 28PX;
  }
}

/* 选中中间Tab时文字变色 */
.center-tab.van-tabbar-item--active {
  color: #FF6633;
  
  .center-icon {
    background: #FF4500;
  }
}
</style>